import { useEffect } from 'react';

import emitter from '@/shared/lib/eventEmitter';

export default function useEmitter(
  key: string,
  callback: (...args: unknown[]) => void,
  deps: unknown[] = [],
  cleanup: () => void = () => {},
) {
  useEffect(() => {
    if (!(key && callback)) return;
    const listener = emitter.addListener(key, callback);
    return () => {
      cleanup();
      listener.remove();
    };
  }, [key, ...deps]);

  return emitter;
}
